import { useId, useState, useEffect } from "react";
import {useTableOfContents} from "../../hooks/tableOfContentsHooks/useTableOfContents";
import {isNullOrEmpty} from "../../utils/isNullOrEmpty";
import PropTypes from "prop-types";
import useAppModernisation from "../../hooks/useAppModernisation";
import styles from "./TableOfContentsMenu.module.scss";
import { isSameItem } from "../../hooks/tableOfContentsHooks/tableOfContents";
import { setTabClickLock } from "../../features/tableOfContents/TableOfContentsSlice";

function TableOfContentsItem({ item }) {
  const tocContext = useTableOfContents();
  const [expanded, setExpanded] = useState(false);
  const hasChildren = item.children && item.children.length > 0;
  const expandId = useId();
  const subItemsId = useId();
  const { isWebModernisationEnabled, isMobileView } = useAppModernisation();

  // Auto-expand if any child is active, close others
  useEffect(() => {
    if (hasChildren && tocContext.activeItem) {
      const hasActiveChild = item.children.some((child) =>
        isSameItem(child, tocContext.activeItem),
      );
      setTabClickLock();
      setExpanded(hasActiveChild);
    }
  }, [tocContext.activeItem, hasChildren, item.children]);

  const toggleExpanded = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  const handleClickOnTitle = (e) => {
    e.stopPropagation();
    setTabClickLock();
    if (isMobileView) {
      tocContext.closeModal();
      tocContext.setSelectedMenuItem(item);
    } else if (isWebModernisationEnabled) {
      tocContext.setSelectedMenuItem(item);
      tocContext.setActiveItem(item);
    }
    window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            "event": 'page_view',
            "_event": 'page_view',
            "C5-EventType": "Request",
            "C5itemID": item?.id?.replace(".ditamap", "")?.replace(".dita", ""),
            "C5titleID": item?.id?.replace(".ditamap", "")?.replace(".dita", ""),
          });
  };

  if (isNullOrEmpty(item)) return null;
  let activeItem = tocContext.isActiveItem(item);
  return (
    <li className={styles.item}>
      <div className={styles.itemWrapper}>
        <span
          className={`${styles.itemButton} ${activeItem ? styles.active : ""}`}
          role="button"
        >
          {hasChildren && (
            <i
              id={expandId}
              className={`tg-icons-Chevron${expanded ? "Up" : "Down"}`}
              onClick={toggleExpanded}
              aria-expanded={expanded}
              aria-label={`Expand Children for: ${item.title}`}
              aria-controls={subItemsId}
            ></i>
          )}
        </span>
        <span
          className={`${styles.itemText} ${activeItem ? styles.active : ""}`}
          onClick={handleClickOnTitle}
          role="button"
          aria-current={activeItem}
        >
          {item.title}
        </span>
      </div>

      {hasChildren && expanded && (
        <ul id={subItemsId}>
          {item.children.map((child) => (
            <TableOfContentsItem key={child.id} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
}

TableOfContentsItem.propTypes = {
  item: PropTypes.object.isRequired,
};


export default TableOfContentsItem;